



























import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  components: {
    "credit-notes-overview": () =>
      import("@/components/app/global/creditNotes/creditNotesOverview.vue")
  }
})
export default class AdminOrderCancellationRequests extends Vue {
  // Props
  @Prop({ required: false, default: [] })
  public routes!: any[];
}
